/** @jsxImportSource @emotion/react */
import { LinkBoxStyle } from "./LinkBox.css";

const LinkBox = ({bg, text, href, explanation}) => {

    return <a css={LinkBoxStyle(bg)} href={href}><span className="text">{text}</span><span className="explanation">{explanation}</span></a>

}

export default LinkBox;